import { ListSubheader, Menu, MenuItem, MenuProps } from "@mui/material";
import { RadioChipOption } from "portal/components/RadioChips";
import React, { FC } from "react";

interface ImageRightClickMenuProps
  extends Pick<MenuProps, "open" | "anchorPosition"> {
  onClose: () => void;
  onExited?: () => void;
  title?: string;
  categoryOptions: RadioChipOption[];
  onOptionClick: (categoryId: string) => void;
  disabled?: boolean;
  disabledMessage?: string;
  disabledOptionIds?: string[]; // category option ids that should not be selectable (e.g. the image's current category).
}
export const ImageRightClickMenu: FC<ImageRightClickMenuProps> = ({
  open,
  onClose,
  onExited,
  anchorPosition,
  title,
  categoryOptions,
  onOptionClick,
  disabled,
  disabledMessage,
  disabledOptionIds,
}) => {
  return (
    <Menu
      open={open}
      onClose={() => {
        onClose();
      }}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      slotProps={{ transition: { onExited } }}
    >
      {title && (
        <ListSubheader className="italic leading-normal">
          {(disabled && disabledMessage) || title}
        </ListSubheader>
      )}
      {categoryOptions.map((opt) => {
        return (
          <MenuItem
            key={opt.id}
            onClick={() => {
              onOptionClick(opt.id);
              onClose();
            }}
            disabled={disabled || disabledOptionIds?.includes(opt.id)}
          >
            <span
              className="inline-block w-3 h-3 rounded-full mr-2"
              style={{ backgroundColor: opt.color?.bg }}
            />
            {opt.name}
          </MenuItem>
        );
      })}
    </Menu>
  );
};
